export class StickyInfoPanel {

    static cssClass = "c-stickyinfopanel";
    hideClass = "--hidden";

    constructor(el = null) {
        this.el = el;
        this.init();
    }

    getElOffset(){
        return ( window.scrollY + window.screen.height ) - this.el.clientHeight;
    }

    manageShow(marker){
        if( this.getElOffset() >= marker.offsetTop){
            this.el.classList.add(this.hideClass);
        }else{
            this.el.classList.remove(this.hideClass);
        }
    }

    monitorShow(){
        if( document.querySelector("[data-stickyinfopanel-disappear]") !== null ){
            var disappearMarker = document.querySelector("[data-stickyinfopanel-disappear]");
            window.addEventListener("scroll", () => {
                this.manageShow(disappearMarker);
            });
        }
    }

    init(){
        this.monitorShow();
    }

}
